import React from 'react';
import { useStore } from '../../../store/rootStore';
import { observer } from 'mobx-react';
import ChatStatusMenu from './atoms/ChatStatusMenu';
import MobileTopBar from './atoms/MobileTopBar';
import classNames from 'classnames';
import styles from './TopContent.module.scss';
const TopContent = () => {
    const { activeChatStore } = useStore();
    const isChatOpen = !!activeChatStore.chat;
    return (React.createElement("div", { className: classNames(styles.container, {
            [styles.chatOpen]: isChatOpen,
        }) },
        React.createElement(MobileTopBar, null),
        React.createElement(ChatStatusMenu, null)));
};
export default observer(TopContent);
